import { EntityColumnOptions, entityColumn } from "components/UI/Table/columns/entity/entityColumn.tsx";
import { FILTER_TYPES } from "components/UI/Table/constants/filter.ts";
import { TableColumnType } from "components/UI/Table/types/table.ts";
import { EntityLinkCell } from "components/UI/Table/UI/EntityLinkCell/EntityLinkCell.tsx";

export const OwnerColumn = <T,>(options: EntityColumnOptions<T, App.Data.UserData>): TableColumnType<T> =>
    entityColumn<T, App.Data.UserData>(
        {
            dataIndex: "owner.nickname",
            key: "owner.nickname",
            sorter: true,
            filterable: true,
            filterType: FILTER_TYPES.partnerSelect,
            filterName: "owner_id",
            sortName: "owner.nickname",
            ellipsis: true,
        },
        (entity) => <EntityLinkCell.Owner entity={entity} />,
        options
    );
